import React, { useState } from "react";
import { FaUserMd, FaMinus, FaPlus, FaFileMedical, FaHeartbeat, FaHospitalUser, FaNotesMedical, FaStethoscope, FaCalendarCheck, FaPrescriptionBottleAlt, FaBriefcaseMedical } from "react-icons/fa";
import Medpalm from "../../../assests/Healthcareprovider/Primarycare.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Comprehensive Health Assessments",
        "description": "Offers full-spectrum health evaluations through detailed physical exams, lab tests, imaging studies (X-rays, MRIs, ultrasounds), and in-depth medical history reviews. These assessments identify early warning signs of conditions such as cardiovascular disease, diabetes, and cancer, enabling timely interventions. Patients receive tailored recommendations, including preventive strategies, lifestyle modifications, and personalized care plans to optimize long-term well-being."
    },
    {
        "title": "Chronic Disease Management",
        "description": "Provides specialized, ongoing care for chronic conditions such as diabetes, hypertension, asthma, heart disease, arthritis, and COPD. Our team develops personalized treatment strategies that include medication optimization, dietary guidance, regular health monitoring, and lifestyle coaching. Continuous follow-ups, remote monitoring tools, and digital health platforms ensure early detection of complications, reducing emergency visits and hospitalizations while improving quality of life."
    },
    {
        "title": "Acute Illness Treatment",
        "description": "Delivers prompt diagnosis and treatment for acute conditions such as infections, seasonal flu, fevers, respiratory illnesses, allergic reactions, gastrointestinal issues, and minor injuries. Patients benefit from rapid lab testing, point-of-care diagnostics, symptom management strategies, and appropriate prescription medications. Our goal is to provide immediate relief, prevent complications, and guide patients toward a smooth and speedy recovery with minimal disruption to their daily lives."
    },
    {
        "title": "Preventive Care & Wellness",
        "description": "Focuses on long-term health maintenance and disease prevention through proactive screenings, routine check-ups, vaccinations, and health risk assessments. Our wellness programs cover personalized nutrition counseling, stress management, sleep hygiene education, and lifestyle coaching. We also offer weight management support, smoking cessation programs, and mental health resources to empower individuals in making sustainable health choices for a better future."
    },
    {
        "title": "Medication Management",
        "description": "Ensures patient safety and treatment efficacy through proper medication management. Our healthcare professionals assess prescriptions for potential drug interactions, adverse effects, and proper dosage adjustments. We provide medication adherence counseling, chronic medication reviews, and personalized treatment plans to minimize risks and maximize therapeutic outcomes. Advanced digital tools and reminders help patients stay on track with their prescribed medications."
    },
    {
        "title": "Care Coordination & Referrals",
        "description": "Facilitates seamless, patient-centered healthcare by connecting individuals with the right specialists, hospitals, and medical facilities. Our care coordination services include arranging specialist consultations, managing medical records, and ensuring continuity of care across various healthcare providers. We assist with referrals for diagnostic tests, surgical procedures, rehabilitation programs, and mental health services, ensuring timely access to the appropriate level of care while reducing administrative burdens for patients."
    }
]


const features = [
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Dedicated primary care physicians for long-term patient relationships." },
    { icon: <FaStethoscope className="text-[#2a627a] text-lg" />, text: "In-depth medical evaluations and patient-centered care." },
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Focus on preventive care to reduce future health risks." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Seamless integration with EHR systems for accurate record-keeping." },
    { icon: <FaCalendarCheck className="text-[#2a627a] text-lg" />, text: "Flexible appointment scheduling for patient convenience." },
    { icon: <FaPrescriptionBottleAlt className="text-[#2a627a] text-lg" />, text: "Efficient prescription management for chronic and acute conditions." }
];

const benefits = [
    { icon: <FaHospitalUser className="text-[#2a627a] text-lg" />, text: "Improves patient health with continuous monitoring and follow-ups." },
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Early detection of diseases through routine screenings." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Enhances coordination between primary care and specialists." },
    { icon: <FaBriefcaseMedical className="text-[#2a627a] text-lg" />, text: "Reduces emergency visits by managing health proactively." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Streamlines medical history management through digital records." },
    { icon: <FaCalendarCheck className="text-[#2a627a] text-lg" />, text: "Encourages regular check-ups for lifelong well-being." }
];
const cmsFeatures = [
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Primary Care Physician – Manages patient health and provides comprehensive medical care." },
    { icon: <FaBriefcaseMedical className="text-[#2a627a] text-lg" />, text: "Nurse Practitioner – Assists with primary care services and patient follow-ups." },
    { icon: <FaStethoscope className="text-[#2a627a] text-lg" />, text: "Physician Assistant – Conducts exams, diagnoses conditions, and prescribes treatments." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Medical Assistant – Supports administrative and clinical tasks in primary care." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Care Coordinator – Ensures smooth patient referrals and follow-ups." },
    { icon: <FaPrescriptionBottleAlt className="text-[#2a627a] text-lg" />, text: "Pharmacist – Manages medication dispensing and patient education on prescriptions." }
];

const PrimaryCarePhysicians = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Primary Care Physicians  - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "At HIKEHEALTH GS, Primary Care Physicians use advanced digital health solutions to improve patient care, streamline workflows, and enhance health outcomes."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is a Primary Care Physician (PCP)?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            A Primary Care Physician (PCP) is the first point of contact for patients, providing preventive care, treating illnesses, managing chronic conditions, and coordinating specialist care.

                            At HIKEHEALTH GS, we empower PCPs with advanced digital health solutions to enhance care, streamline workflows, and improve outcomes.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Primary Care Physicians
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default PrimaryCarePhysicians;
